module.exports = __webpack_public_path__ + "static/infographic-9954823eed6375e761eec1d34b4cd93d.png";